import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { AgreementTemplateSettings } from 'src/containers/Escrow/Agreement';

const AgreementSetup = () => {
  const {
    softwareEscrow: { id, agreement },
  } = useSoftwareEscrow();

  return (
    <SoftwareOnboardingMain
      subtitle="Agreement information:"
      title="Configuration"
      noteText="Define the key terms and legal structure of your escrow agreement."
      classes={{
        note: 'not-italic [&>span]:hidden',
      }}
    >
      <div className="w-[580px] max-w-full mx-auto">
        <AgreementTemplateSettings escrowId={id} isThirdPartyAgreement={Boolean(agreement?.thirdPartyAgreement)} />
      </div>
    </SoftwareOnboardingMain>
  );
};

export default AgreementSetup;
